import { type CardStylingAttributes } from './generated/CardStylingAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { HasCardLayoutHierarchy } from './concerns/HasCardLayoutHierarchy';
import { JsonQuerySerialization } from './concerns/JsonQuerySerialization';
import type Query from '../Query';
import type RecordFields from 'components/CardLayoutEditor/models/RecordFields';
import { type CardLayoutModelConstructorType } from 'components/CardLayoutEditor/models/types';

interface CardStyling extends CardStylingAttributes, HasCardLayoutHierarchy {
  styling: ReturnType<RecordFields['buildCardStyling']>;
}
@model
@HasCardLayoutHierarchy
@JsonQuerySerialization
class CardStyling extends ApplicationModel {
  // Start auto-generated
  static typename: 'CardStyling' = 'CardStyling';
  get typename(): 'CardStyling' {
    return 'CardStyling';
  }

  static inputType = 'CardStylingAttributes';

  static fields = {
    type: attr({ writable: true, readable: true }),
  };
  // End auto-generated

  initialize() {
    const { recordFields } = this.recordLayout;

    this.styling = recordFields.buildCardStyling(this.type);
  }

  /**
   * Appends the necessary scopes to the query for this card styling.
   *
   * @param scope The current query to append to.
   * @returns The final query for the given layout.
   */
  buildScope(scope: Query<CardLayoutModelConstructorType, any>) {
    return this.styling.buildScope(scope);
  }
}

export default CardStyling;
